module.exports = __webpack_public_path__ + "static/media/lhgp_logo.435d416b.jpeg";